<script lang="ts">
	import HomeIcon from "@lucide/svelte/icons/home";
	import KeyRoundIcon from "@lucide/svelte/icons/key-round";
	import StoreIcon from "@lucide/svelte/icons/store";
	import TrendingUpIcon from "@lucide/svelte/icons/trending-up";
	import TreesIcon from "@lucide/svelte/icons/trees";
	import ArrowUpRightIcon from "@lucide/svelte/icons/arrow-up-right";

	const categories = [
		{
			icon: HomeIcon,
			title: "Buy a Home",
			description: "Browse residential homes for sale in the crossroads area.",
			href: "/properties/for-sale?type=Residential",
			cta: "Find homes"
		},
		{
			icon: KeyRoundIcon,
			title: "Find a Rental",
			description: "Apartments, townhomes, and houses available for rent.",
			href: "/properties/for-rent",
			cta: "Find rentals"
		},
		{
			icon: StoreIcon,
			title: "Lease a Space",
			description: "Retail, office, and flex spaces available for lease.",
			href: "/properties/for-lease",
			cta: "Find spaces"
		},
		{
			icon: TrendingUpIcon,
			title: "Investment Properties",
			description: "Single-family, multifamily, and commercial opportunities.",
			href: "/properties/for-sale?type=Multi-Family%2CCommercial",
			cta: "Find investments"
		},
		{
			icon: TreesIcon,
			title: "Buy Land",
			description: "Acreage, ranch, and development land.",
			href: "/properties/for-sale?type=Farm+%26+Ranch%2CLand",
			cta: "Find land"
		}
	];
</script>

<div class="muted bg-background py-10 md:py-14">
	<div class="mx-auto max-w-[84rem] px-4 md:px-6">
		<div class="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
			{#each categories as category}
				<a
					href={category.href}
					class="bg-card group flex flex-col items-center rounded p-5 text-center shadow-sm transition-all duration-200 hover:no-underline hover:shadow-md"
				>
					<div
						class="bg-primary/10 mb-3 flex h-12 w-12 items-center justify-center rounded"
					>
						<category.icon class="text-primary h-6 w-6" />
					</div>
					<h3 class="text-foreground text-sm font-bold">{category.title}</h3>
					<p class="text-muted-foreground mt-1 hidden text-xs sm:block">
						{category.description}
					</p>
					<span
						class="text-primary mt-3 flex items-center gap-1 text-xs font-semibold tracking-wide uppercase"
					>
						{category.cta}
						<ArrowUpRightIcon class="h-3 w-3" />
					</span>
				</a>
			{/each}
		</div>
	</div>
</div>
